// import PropTypes from "prop-types";
// import React, { useEffect } from "react";
// import { Navigate } from "react-router-dom";

// import { logoutUser, oidcLogout } from "../../slices/thunks";
// import { useSelector, useDispatch } from "react-redux";

// import withRouter from "../../Components/Common/withRouter";
// import { createSelector } from "reselect";

// const Logout = (props) => {
//   const dispatch = useDispatch();

//   const logoutData = createSelector(
//     (state) => state.Login,
//     (isUserLogout) => isUserLogout.isUserLogout
//   );
//   // Inside your component
//   const isUserLogout = useSelector(logoutData);

//   useEffect(() => {
//     dispatch(oidcLogout());
//     dispatch(logoutUser());
//   }, [dispatch]);

//   if (isUserLogout) {
//     return <Navigate to="/login" />;
//   }

//   return <></>;
// };

// Logout.propTypes = {
//   history: PropTypes.object,
// };

// export default withRouter(Logout);

///----

// import React, { useEffect } from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { logoutUser, oidcLogout } from "../../slices/thunks";

// const Logout = () => {
//   const dispatch = useDispatch();

//   const isUserLogout = useSelector((state) => state.Login.isUserLogout);
//   const isOidcUser = useSelector((state) => state.Login.isOidcUser);

//   //const { isUserLogout, isOidcLogout } = useSelector((state) => state.Login);
//   // useEffect(() => {
//   //   dispatch(oidcLogout());
//   //   dispatch(logoutUser());
//   // }, [dispatch]);

//   useEffect(() => {
//     if (isOidcUser) {
//       dispatch(oidcLogout()); // Redirect ke provider OIDC logout
//     } else {
//       dispatch(logoutUser()); // Local session logout
//     }
//   }, [dispatch, isOidcUser]);

//   if (isUserLogout || isOidcUser) {
//     return <Navigate to="/login" />;
//   }
//   return <div>Logging out...</div>;
// };

// export default Logout;

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser, oidcLogout } from '../../slices/thunks';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';

const Logout = () => {
  const dispatch = useDispatch();
  const token = getAuthToken();
  const { user, isUserLogout, isOidcLogout, hasOidc } = useSelector(
    state => state.Login
  );
  //const isOidcUser = user?.hasOidc === true;
  const isOidcUser = hasOidc;

  // useEffect(() => {
  //   if (isOidcUser) {
  //     dispatch(oidcLogout());
  //   } else {
  //     dispatch(logoutUser());
  //   }
  // }, [dispatch, isOidcUser]);

  // if (isUserLogout || isOidcLogout) {
  //   return <Navigate to='/login' replace />;
  // }

  // useEffect(() => {
  //   let isMounted = true;
  //   const logoutProcess = async () => {
  //     try {
  //       // 1. Dispatch logout actions
  //       if (isMounted) {
  //         await axios.post(`${api.API_URL}/account/logout`, null, {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             Authorization: `Bearer ${token}`,
  //           },
  //         });
  //       }
  //     } catch (error) {
  //       console.error('Logout error:', error);
  //     } finally {
  //       if (isOidcUser) {
  //         await dispatch(oidcLogout());
  //       } else {
  //         await dispatch(logoutUser());
  //       }
  //     }
  //   };
  //   logoutProcess();
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [dispatch, isOidcUser, token]);

  // useEffect(() => {
  //   let isMounted = true;
  //   const abortController = new AbortController(); // Untuk cancel request

  //   const logoutProcess = async () => {
  //     try {
  //       // 1. Dispatch logout actions TERLEBIH DAHULU
  //       if (isMounted) {
  //         if (isOidcUser) {
  //           await dispatch(oidcLogout());
  //         } else {
  //           await dispatch(logoutUser());
  //         }
  //       }

  //       // 2. Kemudian call API logout
  //       if (isMounted) {
  //         await axios.post(`${api.API_URL}/account/logout`, null, {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             Authorization: `Bearer ${token}`,
  //           },
  //           signal: abortController.signal, // Untuk cancel request
  //         });
  //         console.log('Logout API success');
  //       }
  //     } catch (error) {
  //       if (isMounted) {
  //         // Handle error berdasarkan type
  //         if (axios.isCancel(error)) {
  //           console.log('Logout request cancelled');
  //         }
  //       }
  //     } finally {
  //       // 3. Always cleanup storage dan redirect
  //       if (isMounted) {
  //         cleanupStorage();
  //         cleanupStorage();
  //       }
  //     }
  //   };

  //   // Helper functions
  //   // const cleanupStorage = () => {
  //   //   try {

  //   const cleanupStorage = () => async dispatch => {
  //     try {
  //       await new Promise(resolve => {
  //         sessionStorage.clear();
  //         localStorage.clear();
  //         resolve();
  //       });
  //     } catch (storageError) {
  //       console.error('Storage cleanup error:', storageError);
  //     }
  //   };

  //   logoutProcess();
  //   return () => {
  //     isMounted = false;
  //     abortController.abort(); // Cancel axios request
  //   };
  // }, [dispatch, isOidcUser, token]);

  // if (isUserLogout || isOidcLogout) {
  //   return <Navigate to='/login' replace />;
  // }

  useEffect(() => {
    const executeLogout = async () => {
      try {
        if (isOidcUser) {
          await dispatch(oidcLogout());
        } else {
          await dispatch(logoutUser());
        }
        try {
          await Promise.race([
            axios.post(`${api.API_URL}/account/logout`, null, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }),
            new Promise((_, reject) =>
              setTimeout(() => reject(new Error('Timeout')), 3000)
            ),
          ]);
        } catch (apiError) {
          console.warn('Logout API warning:', apiError.message);
        }
      } catch (error) {
        console.error('Logout process error:', error);
      } finally {
        // 3. Always cleanup and redirect
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/login';
      }
    };

    executeLogout();
  }, [dispatch, isOidcUser, token]);
};

export default Logout;
